module.exports = __webpack_public_path__ + "img/cvc_info.e8d754e4.jpg";